import { define } from '../../define.js';
import { Tabs } from './tabs.js';
export * from './tabs.js';
define('tabs', Tabs);
